import { MonitoringSpecialistsPage } from '@features/monitoringOffer';

export const MonitoringSpecialists = () => {
	return (
		<div className="w-full h-full max-w-[1440px] mx-auto px-5">
			<MonitoringSpecialistsPage />
		</div>
	);
};
